/**
 * `/market/moderation` — search schema.
 *
 *   ?state=open|decided|withdrawn|all   which cases to list. Defaults to
 *   `open`, the SAME default `GET /api/marketplace/moderation/queue` uses
 *   when the parameter is missing — so a bare visit and an explicit
 *   `?state=open` are the same request and the tab that reads as "selected"
 *   always matches what was actually asked for.
 */
import { createFileRoute } from '@tanstack/react-router';

export type MarketModerationState = 'open' | 'decided' | 'withdrawn' | 'all';

export interface MarketModerationSearch {
  /**
   * Optional in the TYPE (so a `<Link to="/market/moderation">` or
   * `to="/market/moderation/$caseId"` needs no `search` prop, matching
   * `MarketEngagementsSearch`) even though `validateMarketModerationSearch`
   * always returns a concrete value at runtime.
   */
  state?: MarketModerationState;
}

const VALID_STATES: ReadonlySet<string> = new Set(['open', 'decided', 'withdrawn', 'all']);

export function validateMarketModerationSearch(
  search: Record<string, unknown>,
): MarketModerationSearch {
  const s = search?.state;
  return { state: typeof s === 'string' && VALID_STATES.has(s) ? (s as MarketModerationState) : 'open' };
}

export const Route = createFileRoute('/_authenticated/market/moderation')({
  validateSearch: validateMarketModerationSearch,
});
